var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{class:{ tiny: _vm.minHeight === 50 },attrs:{"outlined":"","round":"","min-height":_vm.minHeight},on:{"click":function($event){return _vm.select(_vm.points)}}},[_c('v-card-title',[_vm._v(_vm._s(_vm.cardTitle))]),_c('v-card-text',{staticClass:"align-bottom d-none d-sm-flex"},[_vm._v(_vm._s(_vm.spText))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }